// 表头
const formColumns = [
  {
    prop: 'RealName',
    label: '考生姓名',
    // width: "90px",
  },
  {
    prop: 'UserName',
    label: '考生账号',
    // width: "90px",
  },
  {
    prop: 'DepartmentName',
    label: '科室名称',
    // width: "90px",
  },
  {
    prop: 'PTitle',
    label: '职称',
    // width: "90px",
  },
  {
    prop: 'Position',
    label: '职位',
    // width: "90px",
  },
  {
    prop: 'Birthday1',
    label: '出生日期',
    width: '200px',
  },
  {
    prop: 'JobDate',
    label: '工作年限',
    // width: "90px",
  },
];
const options = [
  //切屏次数的选项
  {
    value: '0',
    label: '0',
  },
  {
    value: '1',
    label: '1',
  },
  {
    value: '2',
    label: '2',
  },
  {
    value: '3',
    label: '3',
  },
];
const addFormColumns =  [
    {
      prop: "RealName",
      label: "考生姓名",
      // width: "90px",
    },
    {
      prop: "UserName",
      label: "考生账号",
      // width: "90px",
    },
    {
      prop: "DepartmentName",
      label: "科室名称",
      // width: "90px",
    },
    {
      prop: "PTitle",
      label: "职称",
      // width: "90px",
    },
    {
      prop: "Position",
      label: "职位",
      // width: "90px",
    },
    {
      prop: "Birthday1",
      label: "出生日期",
      width: "200px",
    },
    {
      prop: "JobDate",
      label: "工作年限",
      // width: "90px",
    },
  ]
// 培训方式
export { formColumns, options,addFormColumns };
